import React from 'react';
import { Form } from 'react-bootstrap';

function Input({ icon, type, placeHolder, onChange, value, onBlur, onFocus }) {
    const divStyle = {
        paddingRight: icon ? '50px' : 'auto',
        paddingLeft: icon ? '20px' : 'auto'
    }
    return (
        <div className="input-ue">
            {icon &&
                < img src={icon} alt="input-icon" />
            }
            <Form.Control
                type={type}
                placeholder={placeHolder}
                value={value}
                style={divStyle}
                onChange={onChange}
                onBlur={onBlur}
                onFocus={onFocus}
            />
        </div>
    );
}

export default Input;